import { FunctionComponent } from "react";

import LanguageDropDownSelector from "./layouts/dropdown/dropdown.component";
import LanguageListSelector from "./layouts/list/list.component";
import LanguageToggleSelector from "./layouts/toggle/toggle.component";

type Props = {
    layout: "default" | "list" | "toggle";
    variant?: string;
};

const LanguageSelectorConfig: Record<
    Props["layout"],
    FunctionComponent<Omit<Props, "layout">>
> = {
    default: LanguageDropDownSelector,
    list: LanguageListSelector,
    toggle: LanguageToggleSelector
};

const LanguageSelector = ({ layout = "default", variant }: Props) => {
    const Component = LanguageSelectorConfig[layout];

    return <Component variant={variant} />;
};

export default LanguageSelector;
